import { useState, useEffect } from "react";
import { dashboardService } from "../services/dashboardService";
import { processStatusCounts, createChartData } from "../utils/dashboardHelpers";

export const useAccountClassification = () => {
  const [classificationData, setClassificationData] = useState([]);
  const [rawData, setRawData] = useState([]);
  const [totalAccounts, setTotalAccounts] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await dashboardService.getAccountClassification();
        
        // response might be { data: [...] } or just [...]
        const actualData = response.data || response;
        
        const statusCounts = processStatusCounts(actualData);
        const chartData = createChartData(statusCounts);
        
        setClassificationData(chartData);
        setRawData(actualData);
        const total = chartData.reduce((sum, entry) => sum + entry.value, 0);
        setTotalAccounts(total);
        setError(null);
      } catch (err) {
        console.error("Error fetching account classification:", err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    
    fetchData();
  }, []);

  return { classificationData, rawData, totalAccounts, loading, error };
};